import { friendApis } from '@apis/friendApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const useDeleteFriendInvited = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await friendApis.delete('/friend/invited/{id}/', {
        path: { id },
      });

      return response[204];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/friend/invited/']);
      },
    },
  );
};
